module.exports = __webpack_public_path__ + "img/h11-min.b84bbdda.png";